export default __webpack_public_path__ + "static/media/desk-gadgets.5d966dc7.jpg";